/**
 * @module publicCoach
 * @description The coach fields UserWeb may publish, shared by the pages and
 *   the server's /api/coaches routes
 */

/**
 * The coach fields a public page or API response may embed. Server-rendered
 * props land in the page HTML (`__NEXT_DATA__`) for every visitor and crawler,
 * and the RTDB coach
 * record also holds private fields (`paypalEmail`, `gender`, …), so anything
 * not listed here stays out. Same list as ContentService `PUBLIC_COACH_FIELDS`
 * (ENGBACK-1809), less `gender`, which UserWeb never reads.
 */
const PUBLIC_COACH_FIELDS = [
  'allowFreeCoachingTrial',
  'approved',
  'approvedTrackCount',
  'bio',
  'bioShort',
  'bookable',
  'channels',
  'coachingApproach',
  'coachingClientsCount',
  'coachingEnabledAt',
  'coachingIntroVideo',
  'communities',
  'communityEnabledAt',
  'countryCode',
  'deleted',
  'education',
  'favoritedCount',
  'followersCount',
  'id',
  'key',
  'listenedCount',
  'liveEnabledAt',
  'maxCoachingClients',
  'name',
  'nickname',
  'photo100Url',
  'playedCount',
  'previewCardsBackground',
  'professionalExperienceYears',
  'professionalMemberships',
  'professionalTitle',
  'profileBgRemovedPicture',
  'profileBgRemovedPictureThumbs',
  'profilePicture',
  'profilePictureThumbs',
  'series',
  'slug',
  'specialties',
  'tracks',
  'type',
  'types',
  'videoCoachingApproved',
];

/**
 * @function toPublicCoach
 * @param {Object} coach a coach record
 * @returns {Object|null} only the public fields, for page props
 */
function toPublicCoach(coach) {
  if (!coach) return coach ?? null;
  return Object.fromEntries(
    PUBLIC_COACH_FIELDS.filter((field) => coach[field] !== undefined).map(
      (field) => [field, coach[field]]
    )
  );
}

module.exports = { PUBLIC_COACH_FIELDS, toPublicCoach };
